import React from "react";
import { Box } from "grommet";
import { navItemStyle } from "./tabStyle";

// A plain state-driven tab control (not Grommet's <Tabs>) so it can share
// the exact same active/inactive styling as the top-level NavLink-based
// nav in FunderAllocation.js - consistency was explicitly called out as
// missing between the two.
const DetailTabs = ({ tabs, active, onChange }) => (
    <Box direction="row" gap="small">
        {tabs.map((tab) => (
            <button
                key={tab.key}
                type="button"
                style={navItemStyle(active === tab.key)}
                onClick={() => onChange(tab.key)}
            >
                {tab.label}
            </button>
        ))}
    </Box>
);

export { DetailTabs };
